import { useAppConfig } from "../stores/AppConfigContext";
import {
  getResolvedFeatureFlags,
  isFeatureEnabled
} from "./featureFlagHelpers";
import type { FeatureFlagId } from "./featureFlags";
import type { FeatureFlagsMap } from "../application-config";

/**
 * True when the flag is on via query param, cookie, or application-config.
 * Query and cookie are read live from the active URL / document cookies.
 */
export function useFeatureFlag(flag: FeatureFlagId): boolean {
  const { config } = useAppConfig();
  return isFeatureEnabled(config, flag);
}

/** Registered flags with cookie / query overrides applied. */
export function useFeatureFlags(): FeatureFlagsMap {
  const { config } = useAppConfig();
  return getResolvedFeatureFlags(config);
}
